'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getE3HostNames = exports.postPerformance = exports.getApiHost = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _fetch = require('./config/fetch');

var _fetch2 = _interopRequireDefault(_fetch);

var _hostMap = require('./config/host-map');

var _proxy = require('./config/proxy');

var _proxy2 = _interopRequireDefault(_proxy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var query = _ref.query,
      host = _ref.host,
      _ref$apiHost = _ref.apiHost,
      apiHost = _ref$apiHost === undefined ? (0, _hostMap.getApiHost)(host) : _ref$apiHost,
      ProxyAgent = _ref.ProxyAgent;

  var options = _extends({}, _fetch2.default, {
    body: JSON.stringify(query),
    headers: {
      'content-Type': 'application/json',
      host: /^https?:\/\/(.*)$/.exec(apiHost)[1]
    },
    agent: (0, _proxy2.default)(ProxyAgent)
  });
  var url = apiHost + '/oneshop/cardshopql';
  return (0, _isomorphicFetch2.default)(url, options).then(function (response) {
    return response.json();
  });
};

var postPerformance = function postPerformance(_ref2) {
  var pageName = _ref2.pageName,
      data = _ref2.data,
      host = _ref2.host,
      _ref2$apiHost = _ref2.apiHost,
      apiHost = _ref2$apiHost === undefined ? (0, _hostMap.getApiHost)(host) : _ref2$apiHost;

  var options = _extends({}, _fetch2.default, {
    body: '::' + JSON.stringify(data) + ':::',
    headers: {
      host: /^https?:\/\/(.*)$/.exec(apiHost)[1]
    }
  });
  var url = apiHost + '/us/cardshop-api/api/v1/open/performance/page/' + pageName;
  return (0, _isomorphicFetch2.default)(url, options).then(function (response) {
    return response.json();
  });
};

exports.getApiHost = _hostMap.getApiHost;
exports.postPerformance = postPerformance;
exports.getE3HostNames = _hostMap.getE3HostNames;